<div class="sca-modal-overlay">
  <div class="sca-modal-container">
    <div class="sca-modal-container__content" *ngIf="currentStep !== ScaStep.ERROR">
      <app-sca-method-selection
        *ngIf="currentStep === ScaStep.METHOD_SELECTION"
        [scaDetails]="scaDetails"
        (activeChallenge)="onVerificationMethodSelected($event)"
        (close)="onClose()"
        (error)="onError()">
      </app-sca-method-selection>

      <app-sca-code-verification
        *ngIf="currentStep === ScaStep.CODE_VERIFICATION"
        [activeChallenge]="activeChallenge"
        (chooseDifferentOption)="onChooseDifferentOption()"
        (verified)="onVerificationSuccess()"
        (close)="onClose()"
        (error)="onError()">
      </app-sca-code-verification>
    </div>

    <div class="sca-modal-container__error" *ngIf="currentStep === ScaStep.ERROR">
      <app-checkout-error [primaryActionOverride]="onErrorPrimaryAction"></app-checkout-error>
    </div>
  </div>
</div>
